<template>
  <b-card class="mb-2">
    <b-row>
      <b-col md="12">
        <label>Seria produktu:</label>
        <v-select label="fullName" class="ingredient-name" :options="filteredRawMaterials" v-model="ingredient.selectedRawMaterial"
          @input="changeRawMaterialItemOnList"></v-select>
      </b-col>
      <b-col md="6">
        <label>Dostępna waga:</label>
        <input type="number" class="form-control available-weight" v-model="displayedAvailableWeight"
          disabled="true" />
      </b-col>

      <b-col md="4">
        <label>Użyta waga:</label>
        <input type="number" class="form-control ingredient-weight" step="0.001" v-model="weightSetter" />
        <div class="alert alert-danger" role="alert" v-if="weightError">
          Użyta waga przekracza wagę zasobu na stanie
        </div>
      </b-col>

      <b-col md="2" class="buttons-col-area">
        <button type="button" class="btn btn-primary button-col" @click="RemoveItem">
          Usuń
        </button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import ProductionCommonMethods from "../../mixins/ProductionCommonMethods";
import rawMaterialMixins from '../../mixins/rawMaterials'


export default {
  name: "IngredientForCouverture_item",
  mixins: [ProductionCommonMethods, rawMaterialMixins],
  computed: {
    displayedAvailableWeight() {
      if (!this.ingredient.selectedRawMaterial) return 0;
      // Po pobraniu danych z API, availableWeight jest aktualizowane w getRawMaterialById
      return this.ingredient.selectedRawMaterial.availableWeight || 0;
    }
  },
  watch: {
    weightSetter(weight) {
      // Użyj tej samej logiki co displayedAvailableWeight
      var availableWeight = this.displayedAvailableWeight;

      this.ingredient.usedWeight = weight;
      this.weightError =
        parseFloat(weight) >
        parseFloat(availableWeight);
    },
    rawMaterialType(value) {
      this.getRawMaterialById(value.id)
    }
  },
  mounted() {
    this.weightSetter = this.ingredient.usedWeight;
    this.getRawMaterialById(this.rawMaterialType.id)
    this.$forceUpdate();
  },
  data() {
    return {
      filteredRawMaterials: [],
      weightSetter: 0,
      weightError: false,
    };
  },
  methods: {
    getRawMaterialById(ingredientId) {
      const that = this;
      this.getAvailableRawMaterialsById(ingredientId)
        .then((res) => {
          const ingredientInRecipe = that.recipeIngredients.filter(item => item.ingredientId === ingredientId)[0];

          //Ograniczanie produktów do Eko /Konwencji jeżeli są w recepturze
          if (ingredientInRecipe !== undefined) {
            that.filteredRawMaterials = res.data.filter(item => item.productType === ingredientInRecipe.productType);
          } else {
            that.filteredRawMaterials = res.data;
          }

          // Zaktualizuj availableWeight w selectedRawMaterial z wartością z API
          if (that.ingredient.selectedRawMaterial && that.ingredient.selectedRawMaterial.id) {
            const rawMaterialFromApi = that.filteredRawMaterials.find(
              rm => rm.id === that.ingredient.selectedRawMaterial.id
            );
            if (rawMaterialFromApi) {
              // Zachowaj maxWeightToUse i usedWeight, ale zaktualizuj availableWeight
              that.$set(that.ingredient.selectedRawMaterial, 'availableWeight', rawMaterialFromApi.availableWeight);
            }
          }

        })
        .catch((err) => {
          console.log(err)
          that.filteredRawMaterials = []
        })
    },
    changeRawMaterialItemOnList(item) {
      if (!item) {
        this.ingredient.selectedRawMaterial = this.CreateRawMaterialObject();
      }
    },
    RemoveItem() {
      this.$emit("IngredientForCouvertureRemoveItem", this.ingredient.id);
    },
  },
  props: ["rawMaterials", "ingredient", "rawMaterialType", "recipeIngredients"],
};
</script>